import ReactDOM from 'react-dom/client';
import '@/i18n/i18n.ts';
import { RouterProvider } from '@tanstack/react-router';
import { getRouter } from '@/router.tsx';
import { initObservability } from '@/services/initObservability.ts';

initObservability();
const router = getRouter();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('app')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
}
